import { useCallback, useMemo } from 'react'
import { debounce } from 'lodash'
import { useSelector } from 'react-redux'

import { ApplicationState } from '@/state/root.models'
import { useAppDispatch } from '@/state'
import {
  PersonalizationEngineActions,
  PersonalizationEngineModels,
  PersonalizationEngineThunks,
} from '@/state/personalization-engine'

import { removeEmptyProp } from '@/utils'

export const usePersonalizationEngineActions = () => {
  const dispatch = useAppDispatch()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  const getGameCategories = useMemo(
    () =>
      debounce(
        (
          payload: PersonalizationEngineModels.PersonalizationEngineFiltersType,
        ) => {
          const newFilters = {
            ...payload,
            brandId:
              payload.brandId === '-1'
                ? ''
                : payload.brandId || brand.siteId.toString(),
          }
          dispatch(
            PersonalizationEngineThunks.getAllPersonalizationEngineThunk(
              removeEmptyProp({
                ...newFilters,
              }),
            ),
          )
        },
        500,
      ),
    [brand.siteId, dispatch],
  )

  const getGameProviders = useMemo(
    () =>
      debounce(
        (
          payload: PersonalizationEngineModels.PersonalizationEngineFiltersType,
        ) => {
          const newFilters = {
            ...payload,
            brandId:
              payload.brandId === '-1'
                ? ''
                : payload.brandId || brand.siteId.toString(),
          }

          dispatch(
            PersonalizationEngineThunks.getAllPersonalizationEngineThunk(
              removeEmptyProp({
                ...newFilters,
              }),
            ),
          )
        },
        500,
      ),
    [brand.siteId, dispatch],
  )

  const getFavoriteGames = useMemo(
    () =>
      debounce(
        (
          payload: PersonalizationEngineModels.PersonalizationEngineFiltersType,
        ) => {
          const newFilters = {
            ...payload,
            brandId:
              payload.brandId === '-1'
                ? ''
                : payload.brandId || brand.siteId.toString(),
          }
          dispatch(
            PersonalizationEngineThunks.getFavoriteGamesThunk(
              removeEmptyProp({
                ...newFilters,
              }),
            ),
          )
        },
        500,
      ),
    [brand.siteId, dispatch],
  )

  const setPersonalizationEngineFilters = useCallback(
    (filters: PersonalizationEngineModels.PersonalizationEngineFiltersType) =>
      dispatch(
        PersonalizationEngineActions.setPersonalizationFiltersAction(filters),
      ),
    [dispatch],
  )

  const resetPersonalizationData = useCallback(
    () =>
      dispatch(PersonalizationEngineActions.resetPersonalizationDataAction()),
    [dispatch],
  )

  return {
    getGameCategories,
    getGameProviders,
    getFavoriteGames,
    setPersonalizationEngineFilters,
    resetPersonalizationData,
  }
}
